import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterRole } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterRoleRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  role: MatterRole;
  trigger: ReactNode;
};

export function MatterRoleRowContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  role,
  trigger,
}: MatterRoleRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="matter role"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(role.label, "Role label");
            }}
          >
            <Clipboard />
            Copy role label
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!role.description}
            onSelect={() => {
              void copyToClipboard(role.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
